import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DatabaseConnection } from '../../shared/services/database-connection';
import { Assurance } from '../../shared/model';

interface DashBoardData{
  compteur : any
  classement : any[]
  graph : [{jour_semaine : string, count : number}]
  production : Assurance[]
}

@Injectable({
  providedIn: 'root',
})
export class HomeService {
  constructor(
    private http : HttpClient,
    private  dbConnection : DatabaseConnection
  ){}

  dashboard(){
    return this.http.get<DashBoardData>(this.dbConnection.remoteApiConnection.value + "dashboard")
  }

  relance(){
    return this.http.get<{alert : boolean, relance : number, production : Assurance}>(this.dbConnection.remoteApiConnection.value + "relance")
  }
}
